export default "__VITE_ASSET__f9fed9d8__"